import { Typography, TypographyProps } from '@mui/material';
import { common } from '@mui/material/colors';
import React from 'react';
import { createStyleSheet } from 'utils/helpers';

interface RequiredLabelProps extends TypographyProps {
    label: string;
    required?: boolean;
}

const RequiredLabel: React.FC<RequiredLabelProps> = ({
    label,
    required = true,
    sx,
    ...props
}) => {
    return (
        <Typography component={'span'} {...props}>
            <Typography
                component={'span'}
                sx={{
                    ...styles.label,
                    ...sx,
                }}
            >
                {label}
            </Typography>
            {required && (
                <Typography component={'span'} sx={{ color: '#FF0000' }}>
                    &nbsp;*
                </Typography>
            )}
        </Typography>
    );
};
const styles = createStyleSheet({
    label: {
        color: common.black,
        fontSize: '20px',
    },
});
export default RequiredLabel;
